export default "__VITE_ASSET__4cfa879d__"